module.exports = __webpack_public_path__ + "img/icon_sportMenu_tennis.566c8585.svg";